import { API_URL } from "./apiRoutes";

const addLanguageParamToUrl = (url: string) => {
  const localStorageLng = localStorage.getItem("i18nextLng");
  if (localStorageLng && localStorageLng !== "PL") {
    // Sprawdzenie, czy URL zawiera już parametry
    const separator = url.includes("?") ? "&" : "?";
    return `${separator}userLanguage=${localStorageLng}`;
  } else {
    return "";
  }
};

export const post = async (url: string, data = {}, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    signal,
    body: JSON.stringify(data),
  });
  return await response.json();
};

export const postMultipart = async (url: string, data: FormData, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "POST",
    signal,
    body: data,
  });
  return await response.json();
};

export const get = async (url: string, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    signal,
  });
  return await response.json();
};

export const del = async (url: string, data = {}, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "DELETE",
    mode: "cors",
    signal,
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    body: JSON.stringify(data),
  });
  return await response.json();
};

export const put = async (url: string, data = {}, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "PUT",
    mode: "cors",
    signal,
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    body: JSON.stringify(data),
  });
  return await response.json();
};

const getFullURL = (url: string) => `${API_URL}${url}`;
